import * as React from 'react';

import { Root } from './styled';
import { Adaptive } from '../../styles';


type AlertProps = {
	appearance?: 'danger' | 'warning' | 'success' | 'default';
} & Adaptive;

const Alert: React.SFC<AlertProps> = (props) => {

	return (
		<Root {...props} />
	);
}


Alert.displayName = 'Alert';
Alert.defaultProps = {
	appearance: 'default'
};

export default Alert;